export default __webpack_public_path__ + "static/header-tel-79e624ca12ecca7ed4ebb9a2e1533b1f.svg";